<template>
    <div>
      <div class="styleEditorContent" ref="editorContainer"></div>
      <div v-if="!buttonvisibility" class="flex justify-end mt-3">
          <button @click="addComment" class="mr-2" :class="disableStatus() ? 'btnprimary' : 'btndisabled pointer-events-none'">Add</button>
          <button @click="clearComment" :class="disableStatus() ? 'btnprimary' : 'btndisabled pointer-events-none'">Cancel</button>
      </div>
    </div>
  </template>
   
  <script>
  import { defineComponent } from 'vue';
  import { emitter } from '@/main';
  import _ from 'lodash';
  import Quill from 'quill';
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
   
  export default defineComponent({
    name: 'QuillEditor',
    data() {
      return {
        disableStatusCondition:false,
        isButtonVisible:false,
        quill: null,
        content: '<p><br></p>',
        dummyContent: '<p><br></p>'
      };
    },
    mounted() {
      emitter.off('disableComments');
       emitter.on('disableComments',(data)=>{
        if(data==10403 || data==10417 ||data==10401){
          this.isButtonVisible = false;
        }
        else{
          this.isButtonVisible = true;
        }
      })
      let quillShortEditor = new Quill(this.$refs.editorContainer, {
        theme: 'snow',
        placeholder: 'Comments...',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            [{ 'list': 'ordered' }, { 'list': 'bullet' }]
          ]
        }
      });
      this.quill = quillShortEditor
      this.quill.root.innerHTML = this.content;
      this.dummyContent = this.content
      this.quill.on('text-change', () => {
        this.content = this.quill.root.innerHTML;
        this.$emit('input', this.content);
      });
    },
    watch: {
      value(val) {
        if (val !== this.quill.root.innerHTML) {
          this.quill.root.innerHTML = val;
        }
      }
    },
    props: {
      taskStatusCode: {
      type: [String, Number], 
     },
      value: {
        type: String,
        default: ''
      }
    },
    computed:{
     buttonvisibility() {
      if(this.taskStatusCode=='10403'||this.taskStatusCode=='10417'||this.taskStatusCode=='10418')
      return true
    }
  },
    methods:{
      disableStatus(){
        let disableStatusCondition;
        const contentText = this.content ? this.content.replace(/<[^>]*>/g, '').trim() : '';
        const dummyContentText = this.dummyContent ? this.dummyContent.replace(/<[^>]*>/g, '').trim() : '';
        if (contentText == dummyContentText) {
            disableStatusCondition = false;
        } else {
            disableStatusCondition = true;
        }
        return disableStatusCondition;
    },
      addComment(){
          let addedComments = {
              comments: this.content
          }
          emitter.emit('addedComments', addedComments);
          this.clearComment();
      },
      clearComment(){
          // this.content = this.dummyContent
          this.content = '<p><br></p>';
          this.dummyContent= '<p><br></p>';
          this.quill.root.innerHTML = this.content;
      }
    }
  });
  </script>
   
  <style scoped>
  /* Add any custom styles for your editor here */
  </style>